import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStylization2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C13.1046 21 14 20.1046 14 19V18.5C14 18.4767 14 18.4538 14 18.4312C13.9999 18.0338 13.9998 17.7393 14.0342 17.4779C14.2705 15.683 15.683 14.2705 17.4779 14.0342C17.7394 13.9998 18.0338 13.9999 18.4312 14C18.4538 14 18.4767 14 18.5 14H19C20.1046 14 21 13.1046 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 14.2091 21.2091 16 19 16H18.5C18.0038 16 17.8525 16.0022 17.7389 16.0171C16.8415 16.1353 16.1353 16.8415 16.0171 17.7389C16.0022 17.8525 16 18.0038 16 18.5V19C16 21.2091 14.2091 23 12 23C5.92487 23 1 18.0751 1 12ZM8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7ZM14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8ZM5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12Z",
		fill: "currentColor"
	})
});
export default SvgStylization2;
